

const baseURL = `https://${Shopify.shop}/api/2025-01/graphql.json`;
const storeFrontAccessToken = 'bbd104e7993293f00307e2660e6ae64b';

// Below: is Used to create a customer access token when a user logs in or registers
window.customerAccessTokenCreateQuery = function customerAccessTokenCreateQuery() {
  return `
  mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      userErrors {
        field
        message
      }
    }
  }`;
}



// Below: Handlers for updating customer account details
window.customerUpdateQuery = function customerUpdateQuery() {
  return `
    mutation customerUpdate($customer: CustomerUpdateInput!, $customerAccessToken: String!) {
      customerUpdate(customer: $customer, customerAccessToken: $customerAccessToken) {
        customer {
          firstName
          lastName
        }
        customerUserErrors {
          field
          message
        }
      }
    }
  `;
};



// Below: Handlers for password reset functionality
window.changePasswordQuery = function changePasswordQuery() {
  return `
  mutation ChangePassword($email: String!) {
    customerRecover(email: $email) {
    customerUserErrors {
      code
      field
      message
    }
  }
}`;
}


// General function for sending requests
window.sendGraphQLRequest = async function sendGraphQLRequest(query, variables) {
  try {
    const response = await fetch(baseURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storeFrontAccessToken
      },
      body: JSON.stringify({ query, variables })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('GraphQL Response Error:', errorText);
      throw new Error("GraphQL request failed");
    }

    return await response.json();
  } catch (error) {
    console.error('GraphQL Request Error:', error);
    throw error;
  }
};